// extracted by mini-css-extract-plugin
module.exports = {"headerTimer":"Timer_headerTimer__2ZlLr"};